/* eslint-disable react-hooks/exhaustive-deps */
import React, { Component, Fragment, useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { useTranslation } from "react-i18next";
import * as CPN from "antd";
import * as HMS from "../../../common/component/Index";
import * as Func from "../../../../../helpers/functions";
import Model from "../../../../../constants/Model";
import { ORDER } from '../../../../../constants/Define';
// import Modal from '../../../common/component/Modal';
// import Dropdown from '../../../common/component/Dropdown';
// import { PATHS } from '../../../../../constants/Define';

let orderOnline = ['onepay', 'vnpay', 'onepay_installment', 'pay_at_hotel']

export const EditComponent = (props) => {

    const { t } = useTranslation();
    const loading = props.idBooking === props.item.id && props.reSendMail;
    const sendItem = () => {
        // const { confirm } = Modal;
        // confirm({
        //     title: t(`item.order.confirmResendMail`),
        //     content: props.item.email,
        //     okText: t(`action.send`),
        //     cancelText: t(`action.cancel`),
        //     onOk: () => !loading && props.onResendOrderEmail && props.onResendOrderEmail({ id: props.item.id }),
        // });
        return !loading && props.onResendOrderEmail && props.onResendOrderEmail({ id: props.item.id })
    }
    const exportFile = () => {
        return !loading && props.onExportSaleOrderVoucher && props.onExportSaleOrderVoucher(props.item.id)
    }
    
    return (
        <Fragment>
            <Link to={`/orders/${props.item.id}`} className={`mr-2 colorPrimary`}>
                <CPN.Icon type="eye" className="fs20" />
            </Link>
            {
                props.permisionActions && props.permisionActions.allowResendEmail
                    && (props.item.status === ORDER.STATUS.PAID || props.item.status === ORDER.STATUS.WAITING) &&
                <CPN.Popconfirm
                    title={t(`item.order.confirmResendMail`)}
                    
                    icon={<CPN.Icon type="mail" />}
                    onConfirm={sendItem}
                    okText={t(`action.send`)}
                    cancelText={t(`action.cancel`)}
                >
                    <CPN.Icon type={loading ? "loading" : "mail"}
                        className="mr-2 fs20 colorPrimary" />
                </CPN.Popconfirm>
            }
            {
                (!orderOnline.includes(props.item.paymentType) && props.permisionActions.allowExportVoucher) && 
                <CPN.Popconfirm
                    title={t(`item.order.confirmExportVoucher`)}
                    
                    icon={<CPN.Icon type="export" />}
                    onConfirm={exportFile}
                    okText={t(`action.exportVoucher`)}
                    cancelText={t(`action.cancel`)}
                >
                    <CPN.Icon type="export"
                        className="fs20 colorPrimary" />
                </CPN.Popconfirm>
            }
            
            {/* <Dropdown overlay={
                <CPN.Menu className="action-menu">
                    <CPN.Menu.Item>
                        <Link to={Func.getPathWithParams(PATHS.ORDER.DETAIL.path, { id: props.item.id })} className={`mr-2`}>
                            <CPN.Icon type="eye" className="fs20 mr-1" /> {t(`action.show`)} {t(`action.detail`).toLowerCase()}
                        </Link>
                    </CPN.Menu.Item>
                    {
                        props.permisionActions && props.permisionActions.allowResendEmail && props.item.status === 2 &&
                        <CPN.Menu.Item>
                            <CPN.Menu.Item onClick={sendItem}><CPN.Icon type="mail" className="fs20 mr-1" />{t(`action.resendEmail`)}</CPN.Menu.Item>
                        </CPN.Menu.Item>
                    }
                </CPN.Menu>
            }>
                <CPN.Icon type="more" className="fs20 cursorPointer" />
            </Dropdown> */}
        </Fragment>
    )
};

export const ShowDetailGroupComponent = (props) => {
    const { t } = useTranslation();
    return (props.order && props.order.status !== ORDER.STATUS.UNPAID &&
        <Fragment>
            <CPN.Icon type="eye" className="fs20 colorPrimary" onClick={() => props.onShowDetailGroupVoucher({
                id: props.item.orderId, filters: {
                    groupId: props.item.productVariantId
                }
            })} />
        </Fragment>
    )
};

export const DetailOrderGroupVoucher = (props) => {
    const { t } = useTranslation();
    const [titleOrderItemTable, setTitleOrderItemTable] = useState(Func.getTitleTable(Model.OrdersModel.titleDetailGroupVoucher, [], []));
    const [modelOrderItem, setModelOrderItem] = useState(Model.OrdersModel.titleDetailGroupVoucher);
    const [componentTable, setComponentTable] = useState({
        status: {
            key: 'status',
            render: (status, record) => <HMS.StatusComponent color={status !== 4 ? t(`item.voucher.colorStatus.${status}`) : 'gray'}
                label={t(`item.order.statusDetailGroup.enum.${status}`)} />,
            filters: [
                { value: 4, text: t(`item.order.statusDetailGroup.enum.4`) },
                { value: 7, text: t(`item.order.statusDetailGroup.enum.7`) },
            ],
            filterMultiple: false,
        },
        checkCode: {
            filterDropdown: ({ setSelectedKeys, selectedKeys, confirm, clearFilters }) => (
                <HMS.FilterDropdown
                    setSelectedKeys={setSelectedKeys}
                    selectedKeys={selectedKeys}
                    confirm={confirm}
                    clearFilters={clearFilters}
                >
                </HMS.FilterDropdown>
            ),
            filterIcon: filtered => (
                <CPN.Icon type="search" style={{ color: filtered ? '#1890ff' : undefined }} />
            ),
        }
    });
    const onChange = (pagination, filters, sorter) => {
        let newFilters = Func.genaratePaginateFilterSort(pagination, filters, sorter);
        props.onChange(newFilters)
    };
    return (
        <HMS.PopupModelComponent
            bodyStyle={{
                paddingTop: 0
            }}
            width="50%"
            title={t(`item.order.titleDetailGroupVoucher`)}
            visible={props.showDetailGroupVoucher}
            onClose={(i) => props.onClose(!props.showDetailGroupVoucher)}
            onSubmit={() => props.onClose(!props.showDetailGroupVoucher)}
            cancelText={"Đóng"}
            className={"without-ok-btn"}
        >
            <HMS.LoadingComponent spinning={props.isFetching}>
                <HMS.ListComponent
                    classParent="orderDetailGroup"
                    rowKey={(record, k) => k}
                    dataSource={Func.getDataSource(props.vouchers || [], modelOrderItem)}
                    columns={Func.columnsTable({
                        titleTable: titleOrderItemTable,
                        component: componentTable,
                        itemName: 'order'
                    })}
                    pagination={{ total: props.pagination.totalCount, totalPage: props.pagination.totalPage }}
                    componentTableList={{}}
                    onChange={onChange}
                />
            </HMS.LoadingComponent>
        </HMS.PopupModelComponent>
    )
};

export const RepushAffiliate = (props) => {
    const {
        orderId,
        paymentStatus,
        idBooking = orderId,
        repushAff,
        isAffiliateRepushed = false,
    } = props;
    const [label, setLabel] = useState(props.label);
    const [isRepushSuccess, setRepushSuccess] = useState(0);
    const isPaymentFailed = label === 'LEAD' && (paymentStatus === 1 || paymentStatus === 5)
    const loading = idBooking === orderId && repushAff;
    const style = {
        backgroundColor: label === 'APPROVED' ? '#f6ffed' : (isPaymentFailed ? '#fff7e6' : '#fff1f0'),
        color: label === 'APPROVED' ? '#52c41a' : (isPaymentFailed ? '#fa8c16' : '#f5222d'),
        borderColor: label === 'APPROVED' ? '#b7eb8f' : (isPaymentFailed ? '#ffd591' : '#ffa39e')
    }
    const repushAffiliate = async () => {
        setRepushSuccess(orderId)
        const status = label === 'LEAD' ? 'approved' : 'lead'
        return props.onRepushAffiliate(orderId, status); 
    }
    useEffect(() => {
        if (isAffiliateRepushed && idBooking === orderId && idBooking === isRepushSuccess){
            if (props.label === 'LEAD') {
                setLabel('APPROVED');
            } else if (props.label === 'FAILED') {
                setLabel('LEAD');
            }
        }
    }, [isAffiliateRepushed])
    
    return (
        <>
            {loading ? 
            <CPN.Icon type='loading' className="fs20 colorPrimary" />
                :
            <CPN.Button
                onClick={repushAffiliate}
                disabled={label === 'APPROVED'}
                style={style}
            >
                    {label}
                </CPN.Button>
            }
        </>
    )
}
